<nav class="sideMenu">
    <a *ngFor="let tab of tabs"
       (click)="onTabClick(tab)"
       class="menuItem"
       [class._active]="tab.isSelected"
       [class._messaging]="tab.url === '/mailbox'"
       [captureId]="tab.captureId">
        <!-- Show unread messages notification on mailbox tab -->
        <div *ngIf="tab.url === '/mailbox' && unreadMessageCount > 0">
            <div class="messagingNotification">{{unreadMessageCount}}</div>
        </div>

        <span [class]="'menuItem-icon ' + tab.iconClass"></span>
        <span class="menuItem-value" [i18nKey]="tab.key"></span>
    </a>
</nav>
